import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Grid, Button } from 'semantic-ui-react';

import { DateForm, StatusList, Division, SearchInputBox } from 'components/Commons';

class MyPointForm extends Component {
  render() {
    const { type } = this.props;
    const { division, submitForm, handleEntSubmit } = this.props.formFn;

    return (
      <Form className="top-form">
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={14}>
              <Form.Group>
                <DateForm />
                <SearchInputBox handleSubmit={submitForm} handleEntSubmit={handleEntSubmit} placeHolder="ID, 이름" />
              </Form.Group>
            </Grid.Column>
            <Grid.Column width={2} className="right">
              <Button color="black" inverted content="조회" onClick={submitForm} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Form.Group>
                <StatusList name="type" status={type} defaultOption="사용타입 전체" />
                <Division division={division} />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

MyPointForm = connect((state) => ({
  type: state.usage.pointTypeList
}))(MyPointForm);

export default MyPointForm;
